import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Button, Stack, Typography } from '@mui/material';
import ContentBody from '../../components/ContentBody/ContentBody';
import { ROUTES } from '../../routing/ROUTES';

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ContentBody>
      <Stack
        data-testid="not-found-page"
        spacing={1}
        sx={{ width: '750px', marginTop: '10px', marginLeft: '45px' }}
      >
        <Typography sx={{ fontSize: '45px', color: 'primary.main' }}>
          {t('errorPage.notFoundTitle')}
        </Typography>

        <Typography sx={{ fontSize: '18px', color: 'text.primary', paddingTop: '20px' }}>
          {t('errorPage.notFoundMessage')}
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '35px', alignItems: 'center' }}>
          <Button
            variant="contained"
            onClick={() => navigate(ROUTES.Logout)}
            sx={{
              textTransform: 'none',
              borderColor: 'primary.main',
              color: '#ffffff',
              backgroundColor: 'primary.main',
              fontSize: '16px',
              paddingLeft: '30px',
              paddingRight: '30px'
            }}
          >
            {t('errorPage.goHome')}
          </Button>
        </Box>
      </Stack>
    </ContentBody>
  );
};

export default NotFound;
